<template lang="pug">
.change-and-expansion-card-modal-container()
  .now-money-container
    .change-block(v-if="typeS===3")
      .coverTitle(:style="`background-image: url(${extandData.coverTitleUrl});`")
        //- .coverTime(v-if="extandData.endTime&& nowData<extandData.endTime") {{getTime(extandData.endTime)}}活动结束
      .coupon-flex
        couponChangeItems(:isSmall="true" :item="couponInfo").coupon-items-left(:class="freeExtendPropType ? 'free-extend-prop-type' : ''")
        img(src="https://m.hellobike.com/resource/gallery/350/bI1EpjQU_Frame.png")
        couponChangeItems(:item="extandData" :unOpenCouponGameAB="unOpenCouponGameAB").coupon-items-right
      .unopen-coupon-btn(v-if="unOpenCouponGameAB")
        .unopen-coupon-btn-text
          .unopen-coupon-btn-top 开通后
          .unopen-coupon-btn-bottom {{extandData.expansionType === 2 ? '膨胀至免单' : `最高膨胀至${extandData.amount}元`}}
        img.expansiveImg(src="https://m.hellobike.com/resource/gallery/43/CIxoQH3HVD.png")
      .coupon-btn(v-else @click="changeAndExpansive(2)") {{ freeExtendPropType ? '膨胀至免单' : '膨胀变大'}}
        img.expansiveImg(src="https://m.hellobike.com/resource/gallery/61/c16_gZFT_Frame%20(3).png?x-oss-process=image/quality,q_80")
    .expansive-block(v-else-if="typeS===4")
      couponChangeItems(:item="couponInfo").coupon-items
      .btn-line
        .btn-line-left(v-if="cardList.length>0" @click="changeType") 换掉TA
        .btn-line-right(v-if="couponInfo.afterVipExtendProperty" @click="changeAndExpansive(2)") 膨胀变大
          img(src="https://m.hellobike.com/resource/gallery/61/c16_gZFT_Frame%20(3).png?x-oss-process=image/quality,q_80")
        .btn-line-right(v-else @click="receiveBtn") 领取
    .change-more-block(v-else-if="typeS===1")
      couponChangeItems.copupon-middle(:isSmall="true" :item="couponInfo")
      .middle-up-arrow
        img(src="https://m.hellobike.com/resource/gallery/61/A73-xE7C_Rectangle%20429%20(1).png?x-oss-process=image/quality,q_80")
      .middle-word.fw(:class="{faded: chooseStyle !== null}") {{numberMāp[cardList.length]}}选一
      .middle-change-list(ref="container")
        .list-item(v-for="(item,index) in cardList" :key="item.id"
        :style="{'margin-right': cardList.length > 1 && index < cardList.length - 1 ? '0.109rem' : '0'}"
        :class="{selected: chooseStyle === index &&cardList.length>1,faded: chooseStyle !== null && chooseStyle !== index&&cardList.length>1 }"
        ref="listItem")
          couponChangeItems.list-coupon(:isSmall="true" :item="item")
          .choose-btn(@click="changeAndExpansive(3, index)") 选TA
    .change-more-block(v-else-if="typeS===2")
      couponChangeItems.copupon-middle(:isSmall="true" :item="couponInfo")
      .middle-up-arrow
        img(src="https://m.hellobike.com/resource/gallery/61/A73-xE7C_Rectangle%20429%20(1).png?x-oss-process=image/quality,q_80")
      .middle-word 更换后不可撤回
      couponChangeItems.copupon-middle.marignTop8(:isSmall="true" :item="cardList[chooseIndex]")
      .sure-btn(@click="changeAndExpansive(3)") 确认更换
      .back-btn(@click="moreThink") 再想想
    .receive-packet-close(@click="closeModal")
      img.close(src="https://m.hellobike.com/resource/helloyun/08345/KyfI3xjHl3.png")
    .shadow
    </template>

<script>
import dayjs from 'dayjs';
import {
  propertyReplacement,
} from '@/api/vip';
import Toast from '@/components/toast';
import {
  getTokenAndKey,
  getNoScroll,
} from '@/utils';
import Loading from '@/components/loading';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import 'animate.css';
import couponChangeItems from './coupon-change-items.vue';
import { CouponMapper } from '../utils';
import { safeGet } from '../../../../utils';
import { EXPAND_TYPE } from '../../consts';

export default {
  components: {
    couponChangeItems,
  },
  props: {
    couponInfo: {
      type: Object,
      required: true,
    },
    openChangeType: {
      type: Number,
      default: 0,
    },
    goodsGuid: {
      type: String,
      default: '',
    },
    vipRecordGuid: {
      type: String,
      default: '',
    },
    propVersion: {
      type: String,
      default: '',
    },
    // extandData: {
    //   type: Object,
    //   default: () => ({}),
    // },
    unOpenCouponGameAB: {
      type: Boolean,
      default: false,
      required: false,
    },
    couponGameAB: {
      type: String,
      default: 'N',
      required: false,
    },
  },
  data() {
    return {
      showExpansive: false,
      changeList: [{}, {}, {}, {}],
      typeS: 0,
      numberMāp: {
        1: '一',
        2: '二',
        3: '三',
        4: '四',
      },
      chooseIndex: null,
      chooseStyle: null,
      extandData: {},
      timer: null,
      timers: null,
      loadingTimer: null,
      canClick: true,
      nowData: Date.now(),
      EXPAND_TYPE,
    };
  },
  computed: {
    cardList() {
      if (this.couponInfo.afterVipReplacementProperty) {
        return this.couponInfo.afterVipReplacementProperty.map((i) => CouponMapper(i)); // 置换
      }
      return [];
    },
    // couponZ() {
    //   let obj = {};
    //   obj = this.couponInfo;
    //   obj.amount = '?';
    //   return obj;
    // },
    // 膨胀免单类型
    freeExtendPropType() {
      if (this.couponInfo.afterVipExtendProperty
      && this.couponInfo.afterVipExtendProperty.length > 0) {
        return this.couponInfo.afterVipExtendProperty[0].expansionType === 2;
      }
      return false;
    },
  },
  watch: {
    openChangeType(val) {
      this.typeS = val;
    },
  },
  mounted() {
    getNoScroll(true);
    this.typeS = this.openChangeType;

    const { afterVipExtendProperty } = this.couponInfo;
    const { vipExtendProperty } = this.couponInfo;

    const afterVipExtendPropertyFlag = Array.isArray(afterVipExtendProperty)
      && afterVipExtendProperty.length > 0;
    const vipExtendPropertyFlag = vipExtendProperty && Object.keys(vipExtendProperty).length > 0;

    if (afterVipExtendPropertyFlag || vipExtendPropertyFlag) {
      const extandData = afterVipExtendPropertyFlag ? afterVipExtendProperty[0] : vipExtendProperty;
      this.extandData = CouponMapper(extandData);
      if (
        this.extandData
        && this.extandData.expansionType === this.EXPAND_TYPE.free_expand) {
        this.extandData.amount = '免单特权';
        this.extandData.unit = '';
        this.extandData.afterVipExtendProperty = (Array.isArray(afterVipExtendProperty) && afterVipExtendProperty) || [vipExtendProperty];
        this.extandData.subWord = `最高抵${this.extandData.afterVipExtendProperty[0].propAmount}元`;
      }
    }
  },
  destroyed() {
    this.timer = null;
    this.timers = null;
    this.loadingTimer = null;
  },
  methods: {
    getTime(time) {
      return dayjs(time).format('YYYY.MM.DD');
    },
    changeType() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_Coupon_activity_selection',
        categoryId: 'platform',
        businessInfo: {
          VIPbuttontype: 1,
        },
      });
      this.typeS = 1;
    },
    receiveBtn() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_Coupon_activity_selection',
        categoryId: 'platform',
        businessInfo: {
          VIPbuttontype: 3,
        },
      });
      this.$emit('click-btn', this.couponInfo);
    },
    // 2.开卡后膨胀 3换 4 回收
    async changeAndExpansive(val, index) {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_Coupon_activity_selection',
        categoryId: 'platform',
        businessInfo: {
          VIPbuttontype: 2,
        },
      });
      if (val === 3) {
        UBT.clickButton({
          pageId: 'platform_openedcard_page',
          buttonName: 'platform_Exchange_coupons_confirm',
          categoryId: 'platform',
          businessInfo: {},
        });
      }

      let extendPropType = 0;
      let extendPropGuid = 0;
      if (val === 2) {
        if (Array.isArray(this.couponInfo.afterVipExtendProperty)
          && this.couponInfo.afterVipExtendProperty.length > 0) {
          extendPropType = this.couponInfo.afterVipExtendProperty[0].extendPropType;
          extendPropGuid = this.couponInfo.afterVipExtendProperty[0].guid;
        }
      } else if (val === 3) {
        this.chooseIndex = index;
        if (Array.isArray(this.couponInfo.afterVipReplacementProperty)
          && this.couponInfo.afterVipReplacementProperty.length > 0) {
          extendPropType = this.couponInfo.afterVipReplacementProperty[index].extendPropType;
          extendPropGuid = this.couponInfo.afterVipReplacementProperty[index].guid;
        }
      }
      const { token } = await getTokenAndKey();
      try {
        const res = await propertyReplacement({
          token,
          appCode: 'platform',
          goodsGuid: this.goodsGuid,
          vipRecordGuid: this.vipRecordGuid,
          extendPropType,
          goodsPropertyVersion: this.propVersion,
          goodsType: 1,
          beforeProperty: {
            userVipPropGuid: this.couponInfo.userVipPropGuid,
            propCode: this.couponInfo.propCode,
            propType: this.couponInfo.propType,
            propName: this.couponInfo.propName,
            propDesc: this.couponInfo.propDesc,
            propAmount: this.couponInfo.amount,
            goodsPropDesc: this.couponInfo.goodsPropDesc,
            propThreshold: this.couponInfo.propThreshold,
            propDiscount: this.couponInfo.propDiscount,
            propTimes: this.couponInfo.propTimes,
            propEffectiveDays: this.couponInfo.propEffectiveDays,
            porpIcon: this.couponInfo.porpIcon,
          },
          extendPropGuid,
        });

        if (res.code === 0) {
          if (res.data.waitingTime) {
            Loading.show();
            this.loadingTimer = setTimeout(async () => {
              await Loading.close();
              if (val === 3) {
                this.$emit('success', this.cardList[this.chooseIndex]);
              }
              if (val === 2) {
                const couponInfo = CouponMapper(this.couponInfo.afterVipExtendProperty[0]);
                if (
                  this.couponInfo.afterVipExtendProperty
                && this.couponInfo.afterVipExtendProperty.length > 0
                && this.couponInfo.afterVipExtendProperty[0].expansionType
                && this.couponInfo.afterVipExtendProperty[0].expansionType === 2) {
                  couponInfo.amount = '免单特权';
                  couponInfo.unit = '';
                  couponInfo.subtitle = `最高抵${(safeGet(this.couponInfo, 'afterVipExtendProperty.0.propAmount')) || 0}元`;
                }
                this.$emit('success', couponInfo);
              }
            }, res.data.waitingTime);
          } else {
            if (val === 3) {
              this.$emit('success', this.cardList[this.chooseIndex]);
            }
            if (val === 2) {
              const couponInfo = CouponMapper(this.couponInfo.afterVipExtendProperty[0]);
              if (
                this.couponInfo.afterVipExtendProperty
                && this.couponInfo.afterVipExtendProperty.length > 0
                && this.couponInfo.afterVipExtendProperty[0].expansionType
                && this.couponInfo.afterVipExtendProperty[0].expansionType === 2) {
                couponInfo.amount = '免单特权';
                couponInfo.unit = '';
                couponInfo.subtitle = `最高抵${(safeGet(this.couponInfo, 'afterVipExtendProperty.0.propAmount')) || 0}元`;
              }
              this.$emit('success', couponInfo);
            }
          }
        }
      } catch (e) {
        Toast.show(e);
        this.$emit('update:show', false);
        this.$emit('refresh');
      }
    },
    closeModal() {
      getNoScroll(false);
      this.$emit('update:show', false);
    },
    moreThink() {
      this.typeS = 1;
      this.chooseStyle = null;
    },
    chooseOne(index) {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_Exchange_coupons_choice',
        categoryId: 'platform',
        businessInfo: {},
      });
      if (this.canClick) {
        this.canClick = false;
        this.chooseIndex = index;
        this.chooseStyle = index;
        if (this.cardList.length > 1) {
          this.$nextTick(() => {
            const listItems = this.$refs.listItem;
            const selectedElement = listItems[index];
            const selectedElementRect = selectedElement.getBoundingClientRect();
            const selectedItemWidth = selectedElementRect.width;
            const selectedItemLeft = selectedElementRect.left;
            const selectedItemCenter = selectedItemLeft + selectedItemWidth / 2;
            const windowCenter = window.innerWidth / 2;

            listItems.forEach((item, idx) => {
              if (idx === index) {
                // eslint-disable-next-line no-param-reassign
                item.style.transform = `translateX(${windowCenter - selectedItemCenter}px)`;
              }
            });
            this.timer = setTimeout(() => {
              this.typeS = 2;
              this.canClick = true;
            }, 500);
          });
        } else {
          this.typeS = 2;
          this.canClick = true;
          UBT.moduleExpose({
            pageId: 'platform_openedcard_page',
            categoryId: 'platform',
            moduleId: 'platform_Exchange_coupons_confirm',
            contentId: 'platform_Exchange_coupons_confirm',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
      }
    },
  },
};

</script>
<style lang="less" scoped>
.change-and-expansion-card-modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 240;
  display: flex;
  align-items: center;
  justify-content: center;

  .now-money-container {
    .change-block {
      z-index: 223;
      position: relative;

      .coverTitle {
        width: 100vw;
        height: 0.88rem;
        background-size: 100% 100%;
        position: relative;
        margin-bottom: 0.08rem;

        .coverTime {
          text-align: center;
          font-family: PingFang SC, sans-serif;
          font-size: 0.14rem;
          font-weight: 500;
          line-height: 0.196rem;
          color: #fff;
          padding-top: 0.6rem;
        }
      }

      .coupon-flex {
        display: flex;
        justify-content: center;

        .coupon-items-left {
          margin-top: 0.2rem;
          width: 1.04rem;
          height: 1.24rem;
        }

        .coupon-items-right {
          width: 1.21rem;
          height: 1.44rem;
        }

        img {
          margin: 0.72rem 0.07rem 0;
          width: 0.25rem;
          height: 0.25rem;
        }
      }

      .coupon-btn {
        margin: 0.53rem auto 0 auto;
        width: 1.06rem;
        padding: 0 0.01rem;
        height: 0.32rem;
        background: linear-gradient(180deg, #fa4614 0%, #f60 100%);
        border-radius: 0.5rem;
        text-align: center;
        line-height: 0.32rem;
        color: #fff;
        position: relative;

        img.expansiveImg {
          position: absolute;
          width: 0.35rem;
          height: 0.37rem;
          right: -0.15rem;
          bottom: 0.01rem;
        }
      }

      .unopen-coupon-btn {
        margin: 0.45rem auto 0;
        width: 1.26rem;
        height: 0.38rem;
        background: linear-gradient(90deg, #b3b3b3 0%, #6c747a 100%);
        border-radius: 1.02456rem;
        position: relative;
        color: #fff;
        font-family: "PingFang SC", sans-serif;
        font-weight: 600;
        font-size: 0.14rem;
        line-height: 0.32rem;
        text-align: center;

        .unopen-coupon-btn-text {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .unopen-coupon-btn-bottom {
            font-size: 0.14rem;
            line-height: 0.15rem;
          }

          .unopen-coupon-btn-top {
            font-size: 0.11rem;
            line-height: 0.13rem;
          }
        }

        .expansiveImg {
          position: absolute;
          right: -0.085rem;
          bottom: -0.004rem;
          width: 0.28134rem;
          height: 0.371rem;
        }
      }
    }

    .expansive-block {
      z-index: 223;
      position: relative;

      .coupon-items {
        margin: 0 auto;
        width: 1.21rem;
        height: 1.4413rem;
      }

      .btn-line {
        margin-top: 0.45rem;
        display: flex;
        justify-content: center;
        height: 0.32rem;
        color: #531900;
        text-align: center;
        line-height: 0.32rem;
        font-family: PingFang HK, sans-seri;
        font-size: 0.14rem;
        font-weight: 600;

        .btn-line-left {
          width: 0.86rem;
          border-radius: 0.5rem;
          background: #fff6d9;
        }

        .btn-line-right {
          margin-left: 0.11rem;
          width: 0.86rem;
          border-radius: 0.5rem;
          background: linear-gradient(180deg, #fa4614 0%, #f60 100%);
          position: relative;
          color: #fff;

          img {
            position: absolute;
            width: 0.35rem;
            height: 0.37rem;
            right: -0.15rem;
            bottom: 0.01rem;
          }
        }
      }
    }

    .change-more-block {
      z-index: 223;
      position: relative;

      .card-item {
        .price {
          .num {
            color: #242729;
          }
        }
      }

      .copupon-middle {
        margin: 0 auto;
        width: 1.04rem;
        height: 1.24rem;
      }

      .middle-up-arrow {
        display: flex;
        justify-content: center;

        img {
          width: 0.25rem;
          height: 0.25rem;
          margin-top: 0.08rem;
        }
      }

      .middle-word {
        margin-top: 0.06rem;
        text-align: center;
        font-size: 0.12rem;
        font-weight: 600;
        line-height: 0.22rem;
        color: #fff;
      }

      .fw.faded {
        transition: opacity 0.2s linear;
        opacity: 0;
      }

      .middle-change-list {
        margin-top: 0.08rem;
        padding: 0 0.21rem;
        display: flex;
        justify-content: space-around;
        overflow-x: scroll;
        scrollbar-width: none;
        -ms-overflow-style: none;

        .list-coupon {
          width: 1.04rem;
          height: 1.24rem;
        }

        .list-item {}

        .list-item.selected {
          transition: transform 0.5s ease;
        }

        .list-item.faded {
          transition: opacity 0.2s linear;
          opacity: 0;
        }

        .fade-enter-active,
        .fade-leave-active {
          transition: opacity 1s;
        }

        .fade-enter,
        .fade-leave-to {
          opacity: 0;
        }

        .choose-btn {
          width: 0.73rem;
          height: 0.26rem;
          border-radius: 0.06rem;
          color: #fff;
          background: #fb990f;
          line-height: 0.26rem;
          margin: 0.23rem auto 0 auto;
          text-align: center;
        }
      }

      /* Safari and Chrome */
      .middle-change-list::-webkit-scrollbar {
        display: none;

        /* 隐藏滚动条 */
      }

      .marignTop8 {
        margin-top: 0.08rem;
      }

      .sure-btn {
        width: 0.88rem;
        height: 0.32rem;
        text-align: center;
        line-height: 0.32rem;
        margin: 0.3rem auto 0 auto;
        color: #fff;
        background: #ff5729;
        border-radius: 0.5rem;
        font-size: 0.1651rem;
        font-weight: 500;
      }

      .back-btn {
        margin-top: 0.3rem;
        text-align: center;
        font-size: 0.1651rem;
        font-weight: 500;
        color: #fff;
      }
    }

    .receive-packet-close {
      margin-top: 0.32rem;
      display: flex;
      justify-content: center;
      z-index: 101;
      position: relative;

      .close {
        width: 0.3rem;
        height: 0.3rem;
        z-index: 101;
      }
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
}
</style>
